export interface Assessment {
  AssessmentId: string;
  Version: string;
  Points: number;
  OverallTimeLimit: number;
  TimingMode: string;
  ShareCount: number;
  Sections: Section[];
}

export interface Section {
  SectionId: string;
  Title: string;
  TimeLimit: number;
  Points2: number;
  QuestionCount: number;
  Questions: Question[];
}

export interface Question {
  QuestionId: string;
  Title: string;
  QuestionText: string;
  TimeLimit2: number;
  Points3: number;
  QuestionTypeKey?: string;
  QuestionData?: any;
}

export const timingModeKeys = {
  NotTimed: "not-timed",
  PerAssessment: "per-assessment",
  PerSection: "per-section",
  PerQuestion: "per-question"
} as const;

